// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"9c32a7a4","271":"4ee5e416","453":"c39658c8","455":"785ec870","977":"5cac124b"}[chunkId] + ".chunk.js";
};